import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Anthem Blue Cross and Blue Shield of Ohio",
  shortName: "Anthem BCBS Ohio",
  slug: "anthem-bcbs-ohio-insurance",
  seoTitle: "Anthem BCBS Ohio TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have Anthem Blue Cross Blue Shield of Ohio? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your Anthem BCBS Ohio plan in Coral Springs, FL.",
  seoKeywords:
    "Anthem BCBS Ohio TMS coverage, Anthem Ohio TMS therapy, Anthem BCBS Ohio depression treatment Florida, Anthem Ohio mental health benefits Coral Springs FL, Anthem BCBS Ohio SAINT TMS",
  planType: "Blue Cross Blue Shield affiliate health insurance plan",
  planRegion: "Ohio and surrounding regions",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health and substance use disorder services",
  planSpecificIntro:
    "Anthem Blue Cross and Blue Shield of Ohio is an independent licensee of the Blue Cross Blue Shield Association, providing health insurance coverage to members across Ohio. Anthem BCBS Ohio plans typically include behavioral health benefits that may cover TMS therapy and related neuromodulation treatments when medical necessity criteria are met. However, coverage for TMS, accelerated TMS protocols like SAINT, and other advanced depression treatments varies by individual plan, your specific policy type, and whether the treatment provider is in your plan's network.",
  officialResourceUrl: "https://www.anthem.com/",
  officialResourceLabel: "Anthem Blue Cross Blue Shield official website",
};

export const AnthemBcbsOhioInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default AnthemBcbsOhioInsurance;
